export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(pq => pq.id == id),
    loading: state => state.loading,
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, profileQualifications) {
      state.all = profileQualifications.map(pq => Object.assign(pq, { loading: false }))
      state.loading = false
    },
    set(state, profileQualification) {
      state.all = state.all.filter(o => o.id != profileQualification.id)
      state.all.push(profileQualification)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    },
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('candidate/profile_qualifications')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    update({ commit }, profileQualification) {
      return Vue.$http
        .patch(`candidate/profile_qualifications/${profileQualification.id}`, {
          profileQualification,
        })
        .then(({ data }) => commit('set', Object.assign(data, { loading: false })))
    },
    create({ commit }, profileQualification) {
      return Vue.$http
        .post('candidate/profile_qualifications', { profileQualification })
        .then(response => commit('set', Object.assign(response.data, { loading: false })))
    },
    destroy({ commit, getters }, id) {
      const profileQualification = getters.find(id)

      if (profileQualification) {
        commit('set', Object.assign(profileQualification, { loading: true }))
      } else {
        commit('set', { id, loading: true })
      }

      return Vue.$http.delete(`candidate/profile_qualifications/${id}`).then(
        response => commit('remove', id),
        response => {
          if (profileQualification) {
            commit('set', Object.assign(profileQualification, { loading: false }))
          } else {
            commit('set', { id, loading: false })
          }
        }
      )
    },
  },
}
